export default __webpack_public_path__ + "static/media/autoconsumo-compartido-vecinos.e4518b26.svg";